module.exports = __webpack_public_path__ + "static/media/bell-new.ba6a149a.svg";